import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/AdminLayout';
import api from '../../api';

const DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
const DAYS_FULL = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

function fmt(t) {
  if (!t) return '';
  const [h, m] = t.split(':').map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2,'0')} ${h >= 12 ? 'PM' : 'AM'}`;
}

export default function TimeSlots() {
  const [slots,   setSlots]   = useState([]);
  const [blocked, setBlocked] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form,    setForm]    = useState({ day_of_week: 1, start_time: '09:00' });
  const [blockDate, setBlockDate] = useState('');
  const [blockReason, setBlockReason] = useState('');
  const [saving, setSaving] = useState(false);

  const load = () =>
    Promise.all([api.get('/time-slots'), api.get('/time-slots/blocked')])
      .then(([s, b]) => { setSlots(s.data); setBlocked(b.data); })
      .finally(() => setLoading(false));

  useEffect(() => { load(); }, []);

  const addSlot = async (e) => {
    e.preventDefault();
    setSaving(true);
    // derive end time as start + 30 min
    const [h, m] = form.start_time.split(':').map(Number);
    const totalMin = h * 60 + m + 30;
    const end_time = `${String(Math.floor(totalMin / 60)).padStart(2,'0')}:${String(totalMin % 60).padStart(2,'0')}`;
    await api.post('/time-slots', { ...form, end_time });
    setSaving(false);
    load();
  };

  const toggle = (id, is_active) => api.put(`/time-slots/${id}`, { is_active: !is_active }).then(load);
  const del    = (id)            => api.delete(`/time-slots/${id}`).then(load);

  const blockDay = async (e) => {
    e.preventDefault();
    await api.post('/time-slots/blocked', { blocked_date: blockDate, reason: blockReason });
    setBlockDate(''); setBlockReason('');
    load();
  };
  const unblock = (id) => api.delete(`/time-slots/blocked/${id}`).then(load);

  const grouped = Array.from({ length: 7 }, (_, i) => slots.filter(s => s.day_of_week === i));

  return (
    <AdminLayout>
      <div style={{ marginBottom: '32px' }}>
        <div style={{ color: '#2B7FFF', fontSize: '11px', fontWeight: 700, letterSpacing: '0.14em', textTransform: 'uppercase', marginBottom: '6px' }}>Schedule</div>
        <h1 className="page-title">Time Slots</h1>
      </div>

      {/* ── Add slot ── */}
      <div className="card" style={{ marginBottom: '24px' }}>
        <div style={{ fontSize: '11px', fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.10em', marginBottom: '14px' }}>Add Slot</div>
        <form onSubmit={addSlot} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div style={{ flex: '1 1 140px' }}>
            <label className="label">Day</label>
            <select className="input" value={form.day_of_week} onChange={e => setForm(f => ({ ...f, day_of_week: parseInt(e.target.value) }))}>
              {DAYS_FULL.map((d, i) => <option key={i} value={i}>{d}</option>)}
            </select>
          </div>
          <div style={{ flex: '1 1 120px' }}>
            <label className="label">Start time</label>
            <input className="input" type="time" value={form.start_time} onChange={e => setForm(f => ({ ...f, start_time: e.target.value }))} />
          </div>
          <button type="submit" className="btn btn-primary" disabled={saving} style={{ padding: '10px 24px', whiteSpace: 'nowrap' }}>
            + Add
          </button>
        </form>
        <p style={{ fontSize: '11px', color: '#444', marginTop: '8px' }}>Slot duration is 30 min. Toggle a slot to disable without deleting.</p>
      </div>

      {/* ── Week grid ── */}
      <div className="card" style={{ marginBottom: '24px', overflowX: 'auto' }}>
        <div style={{ fontSize: '11px', fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.10em', marginBottom: '16px' }}>Weekly Schedule</div>
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}><div className="spinner" style={{ margin: '0 auto' }} /></div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(80px, 1fr))', gap: '12px', minWidth: '560px' }}>
            {DAYS.map((day, i) => (
              <div key={i}>
                <div style={{ fontSize: '11px', fontWeight: 700, color: grouped[i].length ? '#2B7FFF' : '#333', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '8px', textAlign: 'center' }}>
                  {day}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  {grouped[i].length === 0 ? (
                    <div style={{ textAlign: 'center', color: '#2a2a2a', fontSize: '11px', padding: '8px 0' }}>—</div>
                  ) : (
                    grouped[i].map(s => (
                      <div key={s.id} style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        padding: '5px 8px', borderRadius: '6px',
                        background: s.is_active ? 'rgba(43,127,255,0.08)' : 'rgba(255,255,255,0.03)',
                        border: `1px solid ${s.is_active ? 'rgba(43,127,255,0.25)' : 'rgba(255,255,255,0.06)'}`,
                      }}>
                        <span style={{ fontSize: '11px', fontWeight: 600, color: s.is_active ? '#2B7FFF' : '#444' }}>
                          {fmt(s.start_time)}
                        </span>
                        <div style={{ display: 'flex', gap: '2px' }}>
                          <button
                            onClick={() => toggle(s.id, s.is_active)}
                            title={s.is_active ? 'Disable' : 'Enable'}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: s.is_active ? '#2B7FFF' : '#444', fontSize: '10px', lineHeight: 1, padding: '2px' }}
                          >
                            {s.is_active ? '●' : '○'}
                          </button>
                          <button
                            onClick={() => del(s.id)}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#3a3a3a', fontSize: '13px', lineHeight: 1, padding: '2px' }}
                          >
                            ×
                          </button>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ── Block dates ── */}
      <div className="card">
        <div style={{ fontSize: '11px', fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.10em', marginBottom: '14px' }}>Block a Date</div>
        <form onSubmit={blockDay} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div style={{ flex: '1 1 140px' }}>
            <label className="label">Date</label>
            <input className="input" type="date" value={blockDate} onChange={e => setBlockDate(e.target.value)} required />
          </div>
          <div style={{ flex: '2 1 180px' }}>
            <label className="label">Reason (optional)</label>
            <input className="input" placeholder="e.g. Holiday" value={blockReason} onChange={e => setBlockReason(e.target.value)} />
          </div>
          <button type="submit" className="btn btn-danger" style={{ padding: '10px 20px', whiteSpace: 'nowrap' }}>Block</button>
        </form>

        {blocked.length > 0 && (
          <div style={{ marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {blocked.map(b => (
              <div key={b.id} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '10px 14px', borderRadius: '6px',
                background: 'rgba(239,68,68,0.05)', border: '1px solid rgba(239,68,68,0.12)',
              }}>
                <div>
                  <span style={{ fontSize: '13px', fontWeight: 600 }}>
                    {new Date(b.blocked_date + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })}
                  </span>
                  {b.reason && <span style={{ fontSize: '12px', color: '#666', marginLeft: '10px' }}>{b.reason}</span>}
                </div>
                <button onClick={() => unblock(b.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#666', fontSize: '13px', padding: '2px 6px' }}>×</button>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
